import Nav from "@/components/frostico/Nav";
import Hero from "@/components/frostico/Hero";
import Marquee from "@/components/frostico/Marquee";
import HowItWorks from "@/components/frostico/HowItWorks";
import Menu from "@/components/frostico/Menu";
import DualCTA from "@/components/frostico/DualCTA";
import FAQ from "@/components/frostico/FAQ";
import Footer from "@/components/frostico/Footer";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#0A0B10] text-white grain font-body overflow-hidden">
      <Nav />
      <main className="relative z-10">
        <Hero />
        <Marquee />
        <HowItWorks />
        <Menu />
        <DualCTA />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
